import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { getSelectedComponentsIndexes, getSelectedLinksIndexes } from "@multiweb/picasso";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { createDeleteSetAction } from "../../actions";
import { LOC_CONNECT_KEY_SPACEBAR, LOC_DELETE_KEY_DELETE, LOC_DUPLICATE, LOC_EDIT } from "../../locKeys";
import { getPicassoState, isOnlyStartActivitySelected, isWorkflowReadOnly } from "../../selectors";
import { WorkflowEditorProps } from "../../types";
import { ToolbarPanelComponent, ToolbarPanelComponentProps } from "./ToolbarPanelComponent";

type StateProps = Pick<ToolbarPanelComponentProps, "selectedComponents" | "selectedLinks" | "isWorkflowReadOnly" | "isOnlyStartActivitySelected" | "connectText" | "editText" | "duplicateText" | "deleteText">;

const createMapStateToProps: (state: IAppState, props: WorkflowEditorProps) => MapStateToProps<StateProps, WorkflowEditorProps, IAppState> = () => (state, { hostKey }) => ({
    selectedComponents: getSelectedComponentsIndexes(getPicassoState(state, hostKey)),
    selectedLinks: getSelectedLinksIndexes(getPicassoState(state, hostKey)),
    isWorkflowReadOnly: isWorkflowReadOnly(state, hostKey),
    isOnlyStartActivitySelected: isOnlyStartActivitySelected(state, hostKey),
    connectText: getPrimaryText(state, LOC_CONNECT_KEY_SPACEBAR) ?? "Propojit (Mezerník)",
    editText: getPrimaryText(state, LOC_EDIT) ?? "Upravit",
    duplicateText: getPrimaryText(state, LOC_DUPLICATE) ?? "Duplikovat",
    deleteText: getPrimaryText(state, LOC_DELETE_KEY_DELETE) ?? "Smazat (Delete)",
});

type DispatchProps = Pick<ToolbarPanelComponentProps, "deleteSet">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, WorkflowEditorProps> = (dispatch, { hostKey }) => ({
    deleteSet: () => dispatch(createDeleteSetAction(hostKey)),
});

export const ToolbarPanel = connect(createMapStateToProps, mapDispatchToProps)(ToolbarPanelComponent);
